export default "__VITE_ASSET__CZgmI2v7__"